<template>
  <div class="gheom-checkboxes" >
    <ul :class="orientation">
      <li v-for="option in options" :key="option.sh"
          >
        <a href="#">
          <!--<input type="checkbox" :id="option.sh" :checked="option.is_checked == true" @change="$emit('input', $event.target.checked)">
          <label :for="option.sh">{{option.sh}}</label>-->
          <CheckboxItem
            @changeditem="onChangedItem"
            :item="option">
          </CheckboxItem>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import CheckboxItem from './CheckboxItem'

export default {
  name: "",
  props: [
    "options", "config"
  ],
  components: {
    CheckboxItem
  },
  data:function(){ 
    return {

    }
  },
  computed: {
    orientation: function(){
      var orient = "";
      (this.config.orientation == "h")? orient = "is--horizontal" : orient = "is--vertical";
      return orient;
    }
  },
  methods: {
    onChangedItem(value, item) {
      this.$emit("changegroup", value, item);
    }
  },
  mounted() {
    /*this.options.forEach((opt) => {
      if(opt.is_all && opt.is_checked){
        this.checkAll();
        return
      }
    })*/
  }
}
</script>

